import { ContentLibraryLinks } from 'constants/staticLinks'
import { LanguageCode } from 'translations/Language'

// TODO: Add it and nl version
export const getContentLibraryLink = (language: string) => {
  switch (language) {
    case LanguageCode.FR:
      return ContentLibraryLinks.FR
    case LanguageCode.DE:
      return ContentLibraryLinks.DE
    case LanguageCode.EN:
      return ContentLibraryLinks.EN
    case LanguageCode.ES:
      return ContentLibraryLinks.ES
    case LanguageCode.NL:
      return ContentLibraryLinks.NL
    default:
      return ContentLibraryLinks.ALL_PURPOSE
  }
}
